import { DONATION_ROUTES, ROUTES } from '@/constants';

//* 페이지가 안 넘기거나 시안과 다른 문구를 쓰는 화면만 덮는다 — 상세가 목록보다 먼저 와야 한다.
const NAV_TITLE_BY_ROUTE = [
  [DONATION_ROUTES.HOME, '고향사랑기부제'],
  [DONATION_ROUTES.GIFTS_DETAIL, '답례품'],
  [DONATION_ROUTES.GIFTS, '답례품'],
  [DONATION_ROUTES.HOMETOWNS_DETAIL, '고향 소개'],
  [DONATION_ROUTES.HOMETOWN_BUSINESS_DETAIL, '지정기부'],
  [DONATION_ROUTES.HOMETOWNS_BUSINESS, '지정기부'],
  [DONATION_ROUTES.MY_DONATIONS, '기부내역'],
  [DONATION_ROUTES.MY_REVIEW_CREATE, '후기작성'],
  [DONATION_ROUTES.MY_REVIEW_EDIT, '후기 수정'],
  [DONATION_ROUTES.MY_REVIEW, '답례품 후기'],
  [DONATION_ROUTES.MY_ETC_NOTICE_DETAIL, '공지사항'],
  [DONATION_ROUTES.MY_ETC_NOTICE, '공지사항'],
  [DONATION_ROUTES.MY_ETC_EVENT_DETAIL, '이벤트'],
  [DONATION_ROUTES.MY_ETC_EVENT, '이벤트'],
  [DONATION_ROUTES.MY_JEJU_RECOMMEND_INFO, '탐나는 제주패스'],
  [DONATION_ROUTES.MY_JEJU_RECOMMEND_MAP, '탐나는 제주패스'],
  [DONATION_ROUTES.MY_INQUIRY_HISTORY, '문의 내역'],
  [DONATION_ROUTES.MY_INQUIRY_PREPARE, '어떤 문의인가요?'],
  [DONATION_ROUTES.MY_INQUIRY_EDIT, '1:1 문의'],
  [ROUTES.MY_ORDERS_DETAIL, '주문내역 상세'],
  [ROUTES.MY_ORDERS, '주문내역'],
  [ROUTES.MY_REVIEWS, '내가 남긴 후기'],
  [ROUTES.EASY_CERTIFICATION, '통합본인인증'],
  [ROUTES.EASY_CERTIFICATION_CALLBACK, '통합본인인증'],
] as const;

export const resolveKakaobankNavTitle = (pathname: string) =>
  NAV_TITLE_BY_ROUTE.find(([route]) => route.isMatchPathname(pathname))?.[1];

export const KAKAOBANK_NAV_SUBTITLE = '웰로 제공 서비스';
